module.exports = __webpack_public_path__ + "72ae208418f36b50e1ec308086d4a31e.png";